"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TOKEN_MIN_LENGTH = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Don’t search for queries that are shorter than this
var TOKEN_MIN_LENGTH = exports.TOKEN_MIN_LENGTH = 3;
var fuzzyDeepContainsCaseInsensitive = function fuzzyDeepContainsCaseInsensitive(object, keys, value) {
  var words = _lodash["default"].chain(object).pick(keys).values().flatten().map(_lodash["default"].toString).map(_lodash["default"].toLower).map(function (phrase) {
    return _lodash["default"].split(phrase, /\s+/);
  }).flatten().value();
  var searchTokens = _lodash["default"].chain(value).toLower().split(/\s+/).reject(_lodash["default"].isEmpty).filter(function (searchToken) {
    return searchToken.length >= TOKEN_MIN_LENGTH;
  }).value();
  return searchTokens.length === 0 || searchTokens.some(function (searchToken) {
    return words.some(function (word) {
      return word.includes(searchToken);
    });
  });
};
var exactDeepContainsCaseInsensitive = function exactDeepContainsCaseInsensitive(object, keys, value) {
  return _lodash["default"].chain(object).pick(keys).values().flatten().map(_lodash["default"].toString).map(_lodash["default"].toLower).some(function (valueToLower) {
    return valueToLower.includes(_lodash["default"].toString(value).toLowerCase());
  }).value();
};
var _default = exports["default"] = function _default(object, keys, value) {
  var trimmedValue = value.trim();
  if (trimmedValue.charAt(0) === "\"" && trimmedValue.charAt(trimmedValue.length - 1) === "\"") {
    return exactDeepContainsCaseInsensitive(object, keys, trimmedValue.substring(1, trimmedValue.length - 1));
  } else {
    return fuzzyDeepContainsCaseInsensitive(object, keys, trimmedValue);
  }
};